import {z} from '@hono/zod-openapi';

/** The report id plus the advertisement id, for the two `car_detail` operations. */
export const priceReportAdParamSchema = z.object({id: z.string(), adId: z.string()});
